import brownBg from '@/assets/gameplay/brown-bg-new.png';
// import handCursor from '@/assets/gameplay/buttons/Hand.svg';
import buttonIconH from '@/assets/gameplay/buttons/buttonsIcon/h.png';
import buttonIconL from '@/assets/gameplay/buttons/buttonsIcon/l.png';
import buttonIconN from '@/assets/gameplay/buttons/buttonsIcon/n.png';
import buttonIconP from '@/assets/gameplay/buttons/buttonsIcon/p.png';
import leafBlueActive from '@/assets/gameplay/buttons/leaf-blue-active.png';
import leafBlueWrong from '@/assets/gameplay/buttons/leaf-blue-wrong.png';
import leafBlue from '@/assets/gameplay/buttons/leaf-blue.png';
import leafGoldActive from '@/assets/gameplay/buttons/leaf-gold-active.png';
import leafGoldWrong from '@/assets/gameplay/buttons/leaf-gold-wrong.png';
import leafGold from '@/assets/gameplay/buttons/leaf-gold.png';
import leafGreenActive from '@/assets/gameplay/buttons/leaf-green-active.png';
import leafGreenWrong from '@/assets/gameplay/buttons/leaf-green-wrong.png';
import leafGreen from '@/assets/gameplay/buttons/leaf-green.png';
import leafMaroonActive from '@/assets/gameplay/buttons/leaf-maroon-active.png';
import leafMaroonWrong from '@/assets/gameplay/buttons/leaf-maroon-wrong.png';
import leafMaroon from '@/assets/gameplay/buttons/leaf-maroon.png';
import completedTick from '@/assets/gameplay/completed-tick.png';
import innerFrame from '@/assets/gameplay/innerFrame.png';
import outerFrame from '@/assets/gameplay/outerFrame.png';
import timeContainer from '@/assets/gameplay/timeContainer.png';

export const IMAGES = {
  brownBg,
  // handCursor,
  buttonIconH,
  buttonIconL,
  buttonIconN,
  buttonIconP,
  leafBlue,
  leafBlueActive,
  leafBlueWrong,
  leafGold,
  leafGoldActive,
  leafGoldWrong,
  leafMaroon,
  leafMaroonActive,
  leafMaroonWrong,
  leafGreen,
  leafGreenActive,
  leafGreenWrong,
  innerFrame,
  outerFrame,
  timeContainer,
  completedTick,
};
